import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccountReducer from '../reducers/account.reducer';

export const selectState = createFeatureSelector<fromAccountReducer.State>(
  fromAccountReducer.featureKey
);

export const getUserProfile = createSelector(selectState, (state) => state.userProfile);
export const getApplicantDetails = createSelector(selectState, (state) => state.applicantDetails);
export const getDashboardCounts = createSelector(selectState, (state) => state.dashboardCounts);
export const getFromPage = createSelector(selectState, (state) => state.fromPage);
export const getRolesPermission = createSelector(selectState, (state) => state.rolesPermissions);